import { reduceSumOn } from '@/services/sanitize.service';

export function getTotalMarket(amendments) {
    return amendments.reduce(
        (acc, amendment) =>
            amendment.amountTTC && (amendment.type === 'market' || amendment.type === 'marketOption')
                ? acc + amendment.amountTTC
                : acc,
        0,
    );
}
export function getTotalAmendments(amendments) {
    const amendmentsType = [
        'tma',
        'choice',
        'conceptionError',
        'executionError',
        'unexpected',
        'marketUpdate',
        'other',
    ];
    return amendments.reduce(
        (acc, amendment) =>
            amendment.amountTTC && amendmentsType.includes(amendment.type) ? acc + amendment.amountTTC : acc,
        0,
    );
}
export function getTotalMarketPlusAmendments(amendments) {
    const amendmentsType = [
        'tma',
        'choice',
        'conceptionError',
        'executionError',
        'unexpected',
        'marketUpdate',
        'marketOption',
        'market',
        'other',
    ];
    return amendments.reduce(
        (acc, amendment) =>
            amendment.amountTTC && amendmentsType.includes(amendment.type) ? acc + amendment.amountTTC : acc,
        0,
    );
}

export function getTotalCaution(deductions) {
    return deductions.reduce(
        (acc, deduction) => (deduction.amountTTC && deduction.type === 'caution' ? acc + deduction.amountTTC : acc),
        0,
    );
}

export function getTotalDeductions(deductions) {
    return deductions.reduce(
        (acc, deduction) => (deduction.amountTTC && deduction.type === 'deduction' ? acc + deduction.amountTTC : acc),
        0,
    );
}

export function getTotalPenalties(deductions) {
    return deductions.reduce(
        (acc, deduction) => (deduction.amountTTC && deduction.type === 'penalty' ? acc + deduction.amountTTC : acc),
        0,
    );
}
export function getTotalDeductionExceptCaution(deductions) {
    return deductions.reduce(
        (acc, deduction) => (deduction.amountTTC && deduction.type !== 'caution' ? acc + deduction.amountTTC : acc),
        0,
    );
}
export function getTotalCie(cies) {
    return reduceSumOn(cies, 'amountTTC');
}

export function getGrantTotal(amendments, deductions, cie, totalCIEResponsability) {
    const totalDeductions = getTotalDeductionExceptCaution(deductions);
    const totalCIE = reduceSumOn(cie, 'amountTTC');
    const totalAmendments = reduceSumOn(amendments, 'amountTTC');
    return totalAmendments + totalCIE - totalCIEResponsability - totalDeductions;
}

export function getSituationMainCompany(invoices, mainCompanyBundleId) {
    return invoices.reduce((acc, invoice) => {
        const distribution = invoice.situationDistribution.find(
            (distribution) => distribution.id === mainCompanyBundleId,
        );
        if (invoice.situationEmissionDate && distribution) {
            return acc + distribution.amountTTC;
        } else {
            return acc;
        }
    }, 0);
}

export function getSituationSubcontractors(invoices, mainCompanyBundleId) {
    return invoices.reduce((acc, invoice) => {
        const distributions = invoice.situationDistribution.filter(
            (distribution) => distribution.id !== mainCompanyBundleId,
        );
        if (invoice.situationEmissionDate && distributions) {
            return acc + distributions.reduce((acc, line) => acc + line.amountTTC, 0);
        } else {
            return acc;
        }
    }, 0);
}
export function getSituationCIE(invoices) {
    return invoices.reduce((acc, invoice) => {
        const distributions = invoice.chargedDeductions.filter((distribution) => distribution.id === 'cie');
        if (invoice.situationEmissionDate && distributions) {
            return acc + distributions.reduce((acc, line) => acc + line.amountTTC, 0);
        } else {
            return acc;
        }
    }, 0);
}
export function getSituationGaranteeDeduction(invoices) {
    return invoices.reduce((acc, invoice) => {
        const distributions = invoice.chargedDeductions.filter(
            (distribution) => distribution.id === 'garanteeDeduction',
        );
        if (invoice.situationEmissionDate && distributions) {
            return acc + distributions.reduce((acc, line) => acc + line.amountTTC, 0);
        } else {
            return acc;
        }
    }, 0);
}
export function getSituationPenalties(invoices) {
    return invoices.reduce((acc, invoice) => {
        const distributions = invoice.chargedDeductions.filter((distribution) => distribution.id === 'penalty');
        if (invoice.situationEmissionDate && distributions) {
            return acc + distributions.reduce((acc, line) => acc + line.amountTTC, 0);
        } else {
            return acc;
        }
    }, 0);
}
export function getSituationOtherDeductions(invoices) {
    return invoices.reduce((acc, invoice) => {
        const distributions = invoice.situationDistribution.filter((distribution) => distribution.id === 'deduction');
        if (invoice.situationEmissionDate && distributions) {
            return acc + distributions.reduce((acc, line) => acc + line.amountTTC, 0);
        } else {
            return acc;
        }
    }, 0);
}
